import React, { ReactNode } from 'react';
import { withSnackbar, ProviderContext } from 'notistack';
import { UnauthenticatedError } from '../../api/core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

interface State {
    isError: boolean;
}

interface Props {
    message?: string | ReactNode;
    showErrorDetails?: boolean;
}

class ErrorBoundary extends React.Component<ProviderContext & RouteComponentProps & Props, State> {
    constructor(props: any) {
        super(props);
        this.state = { isError: false };
    }

    componentDidMount() {
        window.onunhandledrejection = (error: PromiseRejectionEvent) => {
            this.componentDidCatch(error.reason, null);
        }
    }

    componentDidCatch(error: Error, info: any) {
        const { enqueueSnackbar } = this.props;

        if(error instanceof UnauthenticatedError) {
            this.props.history.push('/login');
            
        } else {
            const errorHeader = this.props.message || <FormattedMessage id="error.general" />;
            const errorMessage = this.props.showErrorDetails ?
                <div>
                    <p><b>{errorHeader}</b></p>
                    <p>{error.message}</p>
                </div> :
                errorHeader;
            enqueueSnackbar(errorMessage, { variant: 'error', autoHideDuration: 2000 });
        }
    }

    render() {
        if(this.state.isError) {
            return <>Something dreadful happenned</>
        } else {
            return this.props.children;
        }
    }
}

export default withSnackbar(withRouter(ErrorBoundary));